import { makeAutoObservable } from "mobx";
import {
    deleteRoleEx,
    getRoleExById,
    saveOrUpdate,
    pagingRoleEx
} from 'app/services/RoleExService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { RoleEx } from "app/common/Model/RoleEx";
import { checkSearchObject } from "app/common/LocalFunction";

export default class RoleExStore {
    listAllRoleEx = [];
    searchRoleEx = new SearchObject();
    pageRoleEx = null;
    selectedRoleEx = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingRoleEx = async () => {
        return await pagingRoleEx(this.searchRoleEx)
            .then(({ data }) => {
                this.pageRoleEx = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchRoleEx) => {
        this.searchRoleEx = checkSearchObject(this.searchRoleEx, searchRoleEx);
        this.pagingRoleEx();
    }

    handleOpenFormCreateOrEdit = async (roleExId) => {
        if (Boolean(roleExId)) {
            try {
                const response = await getRoleExById(roleExId);
                const { data } = response;
                this.selectedRoleEx = data;
                this.openFormCreateOrEdit = true;
            } catch (error) {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi")
            }
        } else {
            this.selectedRoleEx = new RoleEx();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateRoleEx = (role, { setSubmitting }) => {
        saveOrUpdate(role)
            .then(() => {
                this.selectedRoleEx = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingRoleEx();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (role) => {
        this.selectedRoleEx = { id: role?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteRoleEx(this.selectedRoleEx?.id)
            .then(() => {
                if (this.searchRoleEx?.pageIndex > 1 && this.pageRoleEx?.content?.length === 1) {
                    this.searchRoleEx.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingRoleEx();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchRoleEx = new SearchObject();
        this.pageRoleEx = null;
        this.selectedRoleEx = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

}
